import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CardDiagnosisProcedure from '../../../../../components/common/CardDiagnosisProcedure/CardDiagnosisProcedure'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { isAIDiagnosis, isPrimaryAIDiagnosis } from '../sharedPanelComponents/sharedAIfunctions'
import { setEncounterField } from '../../../../../redux/sidePanel/sidePanelSlice'
import { CButton } from '@coreui/react-pro'
import PdpmAiModal from '../../../../../components/NewEncounter/PdpmAiModal'
import FEATURES from '../../../../../utils/featuresConstants'

export default function PanelSelectedDiagnosisDisplay({
  onDxToggle,
  onRemoveAll,
  onUpdateAll,
  dxHistory = [],
}) {
  const dispatch = useDispatch()
  const features = useSelector((state) => state.user?.features) || []
  const coding_ai = useSelector((state) => state.sidePanel.panelEncounter?.coding_ai)
  const aiMobileDiagnosisCodes =
    useSelector((state) => state.sidePanel.panelEncounter?.aiDiagnosisCodes) || []
  const aiDxCodes = useSelector((state) => state.sidePanel.panelEncounter?.aiDxCodes)
  const selectedDx = useSelector((state) => state.sidePanel.panelEncounter?.diagnosisCodes) || []
  const isReadOnly = useSelector((state) => state.sidePanel.isReadOnly)
  const service_date_from = useSelector(
    (state) => state.sidePanel.panelEncounter?.service_date_from,
  )

  const flatDxHistory = dxHistory.reduce((sum, obj) => [...sum, ...obj.dxs], [])

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    const reorderedArr = Array.from(selectedDx)
    const [removed] = reorderedArr.splice(result.source.index, 1)
    reorderedArr.splice(result.destination.index, 0, removed)

    onUpdateAll(reorderedArr)
    // dispatch(
    //   setEncounterField({
    //     field: 'diagnosisCodes',
    //     value: reorderedArr,
    //     skipSaveLock: true,
    //   }),
    // )
  }

  return (
    <div className={'PanelDiagnosisDisplay'} style={{ pointerEvents: isReadOnly ? 'none' : '' }}>
      {selectedDx?.length > 0 && features?.includes(FEATURES.DesktopAI) && (
        <div className="remove-all">
          <CButton
            color="light"
            size="sm"
            variant="outline"
            shape="rounded-pill"
            style={{ padding: '4px 24px', fontSize: '14px' }}
            onClick={onRemoveAll}
          >
            Remove All
          </CButton>
          <PdpmAiModal dxCodes={selectedDx} setSelectedDiagnosis={onUpdateAll} />
        </div>
      )}
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => {
            return (
              <div ref={provided.innerRef} className="display-div" {...provided.droppableProps}>
                {selectedDx?.length > 0 ? (
                  selectedDx?.map((item, index) => {
                    const key = item?.code
                    const dxDisplayTags = []

                    if (
                      isAIDiagnosis(
                        coding_ai,
                        [...(aiDxCodes || []), ...aiMobileDiagnosisCodes],
                        features,
                        item?.code,
                      )
                    ) {
                      if (
                        isPrimaryAIDiagnosis(
                          coding_ai,
                          features,
                          item?.code,
                          aiMobileDiagnosisCodes,
                        )
                      ) {
                        dxDisplayTags.push('ai-suggested primary dx')
                      } else {
                        dxDisplayTags.push('ai')
                      }
                    }

                    if (flatDxHistory.find((dx) => dx.code === item.code)) {
                      dxDisplayTags.push('previous')
                    }
                    return (
                      <Draggable key={key} draggableId={key} index={index}>
                        {(provided) => (
                          <CardDiagnosisProcedure
                            item={item}
                            index={index}
                            icon={'minus'}
                            handleAddRemove={onDxToggle}
                            type={'DIAGNOSIS'}
                            serviceDate={service_date_from}
                            innerRef={provided.innerRef}
                            dxDisplayTags={dxDisplayTags}
                            panelSelected={true}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            isAI={isAIDiagnosis(
                              coding_ai,
                              [...(aiDxCodes || []), ...aiMobileDiagnosisCodes],
                              features,
                              item?.code,
                            )}
                          />
                        )}
                      </Draggable>
                    )
                  })
                ) : (
                  <div id="no-results">
                    <p>No results found</p>
                  </div>
                )}
                {provided.placeholder}
              </div>
            )
          }}
        </Droppable>
      </DragDropContext>
    </div>
  )
}
